import script from "./diskusi.vue?vue&type=script&setup=true&lang=ts"
export * from "./diskusi.vue?vue&type=script&setup=true&lang=ts"

import "~/pages/_workflow.css?vue&type=style&index=0&id=374a2477&scoped=true&lang=css&external"
import "./diskusi.vue?vue&type=style&index=1&id=374a2477&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374a2477"]])

export default __exports__